import React, { useEffect, useState, useRef } from "react";
import styles from "./AiChatBody.module.css";
import { PiSparkleThin, PiUserThin } from "react-icons/pi";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import typing from "../../../../Content/icons/lottie/typing_loader.lottie";
import MarkdownRenderer from "../../../MarkdownRenderer/MarkdownRenderer";

export default function AiChatBody({
  allowedPrompts,
  chatHistory,
  greeting,
  suggestions,
  handleSuggestionClick,
  setReplyTo,
  inputRef,
}) {
  const chatEndRef = useRef(null);
  const replyBubbleRef = useRef(null);
  const [selectedText, setSelectedText] = useState("");
  const [selectionPosition, setSelectionPosition] = useState({
    top: 0,
    left: 0,
    visible: false,
  });

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatHistory]);

  const handleMouseUp = (e) => {
    const selection = window.getSelection();
    const selected = selection.toString().trim();

    if (replyBubbleRef.current?.contains(e.target)) return;
    if (!selection || selected.length === 0) {
      setSelectedText("");
      setSelectionPosition({ top: 0, left: 0, visible: false });
      return;
    }
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();

    setSelectionPosition({
      top: rect.top + window.scrollY - 115,
      left: rect.left + window.scrollX - 265,
      visible: true,
    });
    setSelectedText(selected);
  };

  const handleReply = () => {
    setReplyTo(selectedText);
    setSelectedText("");
    setSelectionPosition({ top: 0, left: 0, visible: false });
    window.getSelection().removeAllRanges();
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  if (!chatHistory.length) {
    return (
      <div className={styles.emptyChatContainer}>
        <h2>{greeting}</h2>
        <div style={{ fontSize: "12px" }} className="pt-2">
          Suggested Prompts:
        </div>
        <div className={styles.suggestionList}>
          {suggestions.map((suggestion, index) => (
            <button
              disabled={allowedPrompts === 0}
              key={index}
              className={styles.suggestionButton}
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.chatBody} onMouseUp={handleMouseUp}>
      {chatHistory.map((entry, idx) => (
        <React.Fragment key={idx}>
          {/* User Prompt */}
          <div
            className={`${styles.chatEntry} ${styles.right}`}
            ref={idx === chatHistory.length - 1 ? chatEndRef : null}
          >
            <span className={styles.avatar}>
              <PiUserThin size={22} />
            </span>

            <div className={`${styles.bubble} ${styles.prompt}`}>
              {entry && entry.reply && (
                <div className={styles.replyPreview}>
                  <span className={styles.replyLabel}>
                    <i className="fa fa-reply mr-1" aria-hidden="true" />{" "}
                    {entry.reply}
                  </span>
                </div>
              )}
              {entry.prompt}
            </div>
          </div>

          {/* AI Response */}
          <div className={styles.chatEntry}>
            <span className={styles.avatar}>
              <PiSparkleThin size={22} />
            </span>
            <div
              className={`${styles.bubble} ${styles.response} ${
                entry.isError ? styles.error : ""
              }`}
            >
              {entry.response === null ? (
                <span>
                  <DotLottieReact
                    src={typing}
                    loop
                    autoplay
                    className={styles.typing_loader}
                  />
                </span>
              ) : entry.isError ? (
                entry.response
              ) : (
                <MarkdownRenderer>{entry.response}</MarkdownRenderer>
              )}
            </div>
          </div>
        </React.Fragment>
      ))}
      {selectionPosition.visible && (
        <div
          ref={replyBubbleRef}
          style={{
            top: selectionPosition.top,
            left: selectionPosition.left,
          }}
          className={styles.reply}
          onClick={handleReply}
        >
          <i className="fa fa-reply" aria-hidden="true"></i> Reply
        </div>
      )}

      {/* padding end of chat */}
      <div className="py-4" />
    </div>
  );
}
